import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function uncheckTripSchedule(code: string) {
  return restApiClient.url(constructApiUrl(API.tripsSchedule.uncheck.url, { code })).post()
}
